import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge";
import { isApp } from "@swiggy-private/portal-dineout-context";
import { getBridgeSdk } from "./bridgeSdk";

export const closeWebview = () => {
    getBridgeSdk()
        .close()
        .catch(() => void 0);
};

let swHeaders: GetSwiggyHeadersResponsePayload | undefined;

export const getSwiggyHeaders = async (clearCache = false): Promise<GetSwiggyHeadersResponsePayload | undefined> => {
    // swHeaders is already initialized
    if (swHeaders && !clearCache) {
        return swHeaders;
    }

    // get header value, store & return
    if (isApp()) {
        swHeaders = await getBridgeSdk().getSwiggyHeadersFromClient();
    } else {
        try {
            swHeaders = JSON.parse(localStorage.getItem("swiggy_auth_headers") || "{}");
            return swHeaders;
        } catch (_e) {
            return {} as GetSwiggyHeadersResponsePayload;
        }
    }

    return swHeaders;
};

export const isAndroidPlatform = (platform: string): boolean => {
    const platformKey = platform.toLowerCase();
    return platformKey === "swiggy-android" || platformKey === "an";
};

export const getUserHeaders = () => {
    if (swHeaders) {
        return {
            tid: swHeaders.tid,
            sid: swHeaders.sid,
            deviceId: swHeaders.deviceId,
            token: swHeaders.token,
            versionCode: swHeaders["version-code"],
        };
    }
};
